import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	progressBarAriaLabel: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	progressBarAriaLabel: {
		defaultMessage: 'Progress Bar',
		id: 'common.components.progress-bar.aria-label',
		description: 'Aria label for the progress bar',
	},
});
export default messages;
